import React from "react";
import Tour from "reactour";

function TourGuide(props) {
  return (
    <>
      <Tour
        steps={props.steps}
        isOpen={props.isTourOpen}
        onRequestClose={props.passsedGuid}
        rounded={17}
        showCloseButton={true}
        // disableDotsNavigation={true}
        disableInteraction={true}
        nextButton={<div className="tutorial-next-button">بعدی</div>}
        prevButton={<div className="tutorial-prev-button">قبلی</div>}
        lastStepNextButton={
          <div className="tutorial-last-button" onClick={props.passsedGuid}>
            متوجه شدم
          </div>
        }
        showButtons={true}
        showNavigation={false}
        showNumber={false}
        maskSpace={5}
      />
    </>
  );
}

export default TourGuide;
